import { REPO_NAME, ShortLang } from '@/const'
import font from '../assets/ClashDisplay-Variable.woff2'

export type HeadProps = {
	shortLang: ShortLang
	version?: string
	routes?: string[]
	title: string
}

export class Head {
	static render(page: HeadProps) {
		const { shortLang, routes = [], title } = page

		return /* HTML */ `
			<!DOCTYPE html>
			<html lang="${shortLang}">
				<head>
					<meta charset="utf-8" />
					<title>${title}</title>
					<meta name="viewport" content="width=device-width, initial-scale=1" />
					<link rel="preload" href="${font}" as="font" type="font/woff2" crossorigin="anonymous" />
					<link rel="shortcut icon" type="image/png" href="/favicon_0.png" />
					<meta property="og:image" content="https://zikd.ch/zikd-og.png" />
					${routes.map((route) => `<link rel="prefetch" href="${route}index.html"/>`).join('')}
					<script>
						window.__ROUTES__ = ${JSON.stringify(routes)}
					</script>
					<script src="/index.js" defer=""></script>
					<link rel="stylesheet" type="text/css" href="/index.css" />

					<script
						async
						defer
						src="https://static.cdn.prismic.io/prismic.js?new=true&repo=${REPO_NAME}"
					></script>
				</head>
			</html>
		`
	}
}
